<template>
  <BaseBlock
    :class="$attrs.class"
    class="m_flex m_flex-column m_gap26 m_align-center"
  >
    <BaseLoader
      :size="80"
      :width="8"
      variant="page"
    />
    <BaseText class="m_h4 m_color-accent m_page-loader-text">
      Загрузка...
    </BaseText>
  </BaseBlock>
</template>

<script lang="ts">
import BaseBlock from '@/shared/lib/uikit/components/BaseBlock/BaseBlock.vue';
import BaseLoader from '@/shared/lib/uikit/components/BaseLoader/BaseLoader.vue';
import BaseText from '@/shared/lib/uikit/components/BaseText/BaseText.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'AppPageLoader',
  components: { BaseText, BaseLoader, BaseBlock },
});
</script>
